// Handle smooth scroll to calendar section with header offset
function scrollToCalendarSection() {
  const section = document.getElementById('calendar-section');
  if (!section) return;

  const headerHeight = document.querySelector('.header')?.offsetHeight || 92;
  const offset = headerHeight - 5;
  const sectionTop = section.getBoundingClientRect().top + window.scrollY;
  const targetPosition = sectionTop - offset;

  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
}

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="#calendar-section"]');
  if (link) {
    e.preventDefault();
    scrollToCalendarSection();
    
    if (history.pushState) {
      history.pushState(null, null, '#calendar-section');
    }
  }
});

if (window.location.hash === '#calendar-section') {
  window.addEventListener('load', () => {
    setTimeout(() => {
      scrollToCalendarSection();
    }, 100);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.availability-calendar__wrapper');
  const dailyCollection = wrapper?.dataset.dailyCollection;
  const monthlyCollection = wrapper?.dataset.monthlyCollection;
  const tabButtons = document.querySelectorAll('.availability-calendar__tab-button');
  const filterGroups = document.querySelectorAll('.availability-calendar__filters-group');
  const tabContents = document.querySelectorAll('.availability-calendar__tab-content');
  const titleType = document.getElementById('availability-calendar-title-type');
  const titleValue = document.getElementById('availability-calendar-title-value');
  const filterItems = document.querySelectorAll('.availability-calendar__filters-list .swiper-slide');
  
  let swiperInstances = {};
  let currentActiveTab = 'daily';
  let filterAnimationTimeout = null;
  let isFirstMonthlyVisit = true; // Track first visit to monthly tab
  
  // Store all slides data
  const slidesData = {
    daily: [],
    monthly: []
  };

  // DOM Parser for parsing fetched HTML
  const domParser = new DOMParser();

  // Init filter swipers
  filterGroups.forEach(group => {
    new Swiper(group, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: true,
    });
  });

  // Show loading state
  function showLoading(tabName) {
    const content = document.querySelector(`.availability-calendar__tab-content[data-tab="${tabName}"]`);
    const loading = content?.querySelector('.availability-calendar__loading');
    if (loading) {
      loading.classList.add('is-active');
    }
  }

  // Hide loading state
  function hideLoading(tabName) {
    const content = document.querySelector(`.availability-calendar__tab-content[data-tab="${tabName}"]`);
    const loading = content?.querySelector('.availability-calendar__loading');
    if (loading) {
      loading.classList.remove('is-active');
    }
  }

  // Fetch products from collection with pagination
  async function fetchCollectionProducts(collectionHandle, page = 1) {
    const url = `/collections/${collectionHandle}?section_id=availability-calendar-products&page=${page}`;
    
    try {
      const response = await fetch(url);
      const html = await response.text();
      const doc = domParser.parseFromString(html, 'text/html');
      const container = doc.querySelector('.availability-calendar-products');
      
      if (!container) {
        return { products: [], totalPages: 1 };
      }
      
      const totalPages = parseInt(container.dataset.pages) || 1;
      const products = Array.from(container.querySelectorAll('.availability-calendar-product'));
      
      return { products, totalPages };
    } catch (error) {
      console.error('Error fetching products:', error);
      return { products: [], totalPages: 1 };
    }
  }

  // Load all products from collection (handles pagination)
  async function loadAllProducts(collectionHandle) {
    const allProducts = [];
    
    // First fetch to get total pages
    const firstPage = await fetchCollectionProducts(collectionHandle, 1);
    allProducts.push(...firstPage.products);
    
    // Fetch remaining pages in parallel if more than 1 page
    if (firstPage.totalPages > 1) {
      const pagePromises = [];
      for (let page = 2; page <= firstPage.totalPages; page++) {
        pagePromises.push(fetchCollectionProducts(collectionHandle, page));
      }
      
      const results = await Promise.all(pagePromises);
      results.forEach(result => {
        allProducts.push(...result.products);
      });
    }
    
    return allProducts;
  }

  // Process loaded products and store slides data
  function processProducts(products, tabType) {
    const seenProductIds = new Set();
    
    products.forEach(productEl => {
      const type = productEl.dataset.type;
      const filters = productEl.dataset.filters || '';
      const productId = productEl.dataset.productId;
      
      // Skip duplicates
      if (seenProductIds.has(`${type}-${productId}`)) {
        return;
      }
      seenProductIds.add(`${type}-${productId}`);
      
      // Only process products matching the tab type
      if (type !== tabType) return;
      
      const slideHtml = `<div class="swiper-slide" data-filters="${filters}">${productEl.innerHTML}</div>`;
      
      slidesData[tabType].push({
        html: slideHtml,
        filters: filters.split(',').map(f => f.trim().toLowerCase()).filter(f => f)
      });
    });
  }

  // Load products for a specific tab
  async function loadTabProducts(tabName) {
    const collectionHandle = tabName === 'daily' ? dailyCollection : monthlyCollection;
    
    if (!collectionHandle) {
      console.warn(`No collection configured for ${tabName} tab`);
      hideLoading(tabName);
      return;
    }
    
    showLoading(tabName);
    
    try {
      const products = await loadAllProducts(collectionHandle);
      processProducts(products, tabName);
      
      // Initialize swiper after loading
      ensureFilterHasProducts(tabName);
      const activeFilter = document.querySelector(`.availability-calendar__filters-group[data-tab="${tabName}"] .swiper-slide.is-active`);
      if (activeFilter) {
        const filterValue = activeFilter.getAttribute('data-full-value') || activeFilter.getAttribute('data-value');
        rebuildSwiper(tabName, filterValue);
      }
    } catch (error) {
      console.error(`Error loading ${tabName} products:`, error);
    } finally {
      hideLoading(tabName);
    }
  }

  // Get swiper config
  function getSwiperConfig(tabName, slidesCount) {
    const content = document.querySelector(`.availability-calendar__tab-content[data-tab="${tabName}"]`);
    const wrapper = content?.closest('.availability-calendar__tab-content-wrapper');
    const prevBtn = wrapper?.querySelector('.availability-calendar__nav-button--prev');
    const nextBtn = wrapper?.querySelector('.availability-calendar__nav-button--next');
    
    return {
      slidesPerView: 'auto',
      centeredSlides: true,
      centerInsufficientSlides: true,
      centeredSlidesBounds: true,
      spaceBetween: 8,
      loop: slidesCount >= 3,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        1024: {
          spaceBetween: 24,
        },
      },
    };
  }

  // Rebuild swiper with filtered slides
  function rebuildSwiper(tabName, filterValue) {
    const content = document.querySelector(`.availability-calendar__tab-content[data-tab="${tabName}"]`);
    if (!content) return 0;

    const swiperWrapper = content.querySelector('.availability-calendar__swiper-wrapper');
    const emptyMessage = document.querySelector(`.availability-calendar__empty-message[data-tab="${tabName}"]`);
    
    // Destroy existing swiper
    if (swiperInstances[tabName]) {
      swiperInstances[tabName].destroy(true, true);
      swiperInstances[tabName] = null;
    }
    
    // Clear wrapper
    swiperWrapper.innerHTML = '';
    
    // Filter and add slides
    const filteredSlides = slidesData[tabName].filter(slide => {
      if (filterValue === 'alldays') return true;
      return slide.filters.includes(filterValue.toLowerCase());
    });
    
    // Add filtered slides to wrapper (duplicate if less than 20)
    const needsDuplication = filteredSlides.length > 0 && filteredSlides.length > 3 && filteredSlides.length < 20;
    const slidesToAdd = needsDuplication ? [...filteredSlides, ...filteredSlides] : filteredSlides;
    
    slidesToAdd.forEach(slide => {
      swiperWrapper.insertAdjacentHTML('beforeend', slide.html);
    });
    
    // Show/hide empty message
    if (emptyMessage) {
      if (filteredSlides.length === 0) {
        emptyMessage.classList.add('is-active');
      } else {
        emptyMessage.classList.remove('is-active');
      }
    }
    
    // Create new swiper if there are slides
    if (filteredSlides.length > 0) {
      const config = getSwiperConfig(tabName, filteredSlides.length);
      swiperInstances[tabName] = new Swiper(content, config);
    }
    
    return filteredSlides.length;
  }

  // Check if filter has products
  function filterHasProducts(tabName, filterValue) {
    if (filterValue === 'alldays') {
      return slidesData[tabName].length > 0;
    }
    
    return slidesData[tabName].some(slide => {
      return slide.filters.includes(filterValue.toLowerCase());
    });
  }

  // Find next filter with products
  function ensureFilterHasProducts(tabName) {
    const filterGroup = document.querySelector(`.availability-calendar__filters-group[data-tab="${tabName}"]`);
    if (!filterGroup) return;

    const filterButtons = Array.from(filterGroup.querySelectorAll('.swiper-slide'));
    const activeFilter = filterGroup.querySelector('.swiper-slide.is-active');
    
    if (!activeFilter) return;

    const currentFilterValue = activeFilter.getAttribute('data-full-value') || activeFilter.getAttribute('data-value');
    
    if (filterHasProducts(tabName, currentFilterValue)) {
      return;
    }

    // Find next filter with products
    const startIndex = filterButtons.indexOf(activeFilter);
    
    for (let i = 1; i < filterButtons.length; i++) {
      const nextIndex = (startIndex + i) % filterButtons.length;
      const nextFilter = filterButtons[nextIndex];
      const nextFilterValue = nextFilter.getAttribute('data-full-value') || nextFilter.getAttribute('data-value');
      
      if (filterHasProducts(tabName, nextFilterValue)) {
        // Switch to this filter
        filterButtons.forEach(f => f.classList.remove('is-active'));
        nextFilter.classList.add('is-active');
        
        // Update title
        titleValue.textContent = nextFilterValue;
        break;
      }
    }
  }

  // Set current month as active on first visit to monthly tab
  function setCurrentMonthActive() {
    const monthlyFilterGroup = document.querySelector('.availability-calendar__filters-group[data-tab="monthly"]');
    if (!monthlyFilterGroup) return;

    const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    const currentMonthIndex = new Date().getMonth(); // 0-11
    const currentMonthValue = monthNames[currentMonthIndex];

    const filterButtons = Array.from(monthlyFilterGroup.querySelectorAll('.swiper-slide'));
    const currentMonthButton = filterButtons.find(btn => btn.getAttribute('data-value') === currentMonthValue);

    if (currentMonthButton) {
      filterButtons.forEach(f => f.classList.remove('is-active'));
      currentMonthButton.classList.add('is-active');

      const fullMonthName = currentMonthButton.getAttribute('data-full-value') || currentMonthButton.getAttribute('data-value');
      titleValue.textContent = fullMonthName;
    }
  }

  // Tab click with fade animation
  tabButtons.forEach(button => {
    button.addEventListener('click', async () => {
      const targetTab = button.getAttribute('data-tab');
      if (currentActiveTab === targetTab) return;
      
      const previousTab = currentActiveTab;
      currentActiveTab = targetTab;

      // Set current month active on first visit to monthly tab
      if (targetTab === 'monthly' && isFirstMonthlyVisit) {
        setCurrentMonthActive();
        isFirstMonthlyVisit = false;
      }

      // Update buttons
      tabButtons.forEach(btn => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      // Update filter groups
      filterGroups.forEach(group => {
        group.classList.toggle('is-active', group.getAttribute('data-tab') === targetTab);
      });

      // Get wrappers
      const currentWrapper = document.querySelector(`.availability-calendar__tab-content[data-tab="${previousTab}"]`)?.closest('.availability-calendar__tab-content-wrapper');
      const targetWrapper = document.querySelector(`.availability-calendar__tab-content[data-tab="${targetTab}"]`)?.closest('.availability-calendar__tab-content-wrapper');
      
      // Fade out current wrapper
      if (currentWrapper) {
        currentWrapper.style.opacity = '0';
        
        const handleTransitionEnd = async (e) => {
          if (e.propertyName !== 'opacity') return;
          currentWrapper.removeEventListener('transitionend', handleTransitionEnd);
          
          // Switch content
          tabContents.forEach(content => {
            const wrapper = content.closest('.availability-calendar__tab-content-wrapper');
            if (content.getAttribute('data-tab') === targetTab) {
              content.classList.add('is-active');
              if (wrapper) wrapper.classList.add('is-active');
            } else {
              content.classList.remove('is-active');
              if (wrapper) wrapper.classList.remove('is-active');
            }
          });

          // Load products if not loaded yet
          if (slidesData[targetTab].length === 0) {
            await loadTabProducts(targetTab);
          } else {
            // Apply filter to target tab
            ensureFilterHasProducts(targetTab);
            const activeFilter = document.querySelector(`.availability-calendar__filters-group[data-tab="${targetTab}"] .swiper-slide.is-active`);
            if (activeFilter) {
              const filterValue = activeFilter.getAttribute('data-full-value') || activeFilter.getAttribute('data-value');
              rebuildSwiper(targetTab, filterValue);
            }
          }

          // Fade in target wrapper
          if (targetWrapper) {
            targetWrapper.style.opacity = '1';
          }
        };
        
        currentWrapper.addEventListener('transitionend', handleTransitionEnd);
      } else {
        // No current wrapper, switch immediately
        tabContents.forEach(content => {
          const wrapper = content.closest('.availability-calendar__tab-content-wrapper');
          if (content.getAttribute('data-tab') === targetTab) {
            content.classList.add('is-active');
            if (wrapper) wrapper.classList.add('is-active');
          } else {
            content.classList.remove('is-active');
            if (wrapper) wrapper.classList.remove('is-active');
          }
        });

        // Load products if not loaded yet
        if (slidesData[targetTab].length === 0) {
          await loadTabProducts(targetTab);
        } else {
          ensureFilterHasProducts(targetTab);
          const activeFilter = document.querySelector(`.availability-calendar__filters-group[data-tab="${targetTab}"] .swiper-slide.is-active`);
          if (activeFilter) {
            const filterValue = activeFilter.getAttribute('data-full-value') || activeFilter.getAttribute('data-value');
            rebuildSwiper(targetTab, filterValue);
          }
        }

        if (targetWrapper) {
          targetWrapper.style.opacity = '1';
        }
      }

      // Update title
      titleType.textContent = targetTab === 'daily' ? 'daily' : 'seasonal';
      const activeFilter = document.querySelector(`.availability-calendar__filters-group[data-tab="${targetTab}"] .swiper-slide.is-active`);
      if (activeFilter) {
        titleValue.textContent = activeFilter.getAttribute('data-full-value') || activeFilter.getAttribute('data-value');
      }
    });
  });

  // Filter click with fade animation
  filterItems.forEach(item => {
    item.addEventListener('click', () => {
      const parentGroup = item.closest('.availability-calendar__filters-group');
      const targetTab = parentGroup.getAttribute('data-tab');

      parentGroup.querySelectorAll('.swiper-slide').forEach(s => s.classList.remove('is-active'));
      item.classList.add('is-active');
      titleValue.textContent = item.getAttribute('data-full-value') || item.getAttribute('data-value');

      const content = document.querySelector(`.availability-calendar__tab-content[data-tab="${targetTab}"]`);
      const wrapper = content?.closest('.availability-calendar__tab-content-wrapper');
      
      if (wrapper) {
        // Clear previous timeout
        if (filterAnimationTimeout) {
          clearTimeout(filterAnimationTimeout);
        }
        
        // Force opacity to 1 then to 0
        wrapper.style.opacity = '0';
        
        filterAnimationTimeout = setTimeout(() => {
          const filterValue = item.getAttribute('data-full-value') || item.getAttribute('data-value');
          rebuildSwiper(targetTab, filterValue);
          
          // Ensure opacity returns to 1
          wrapper.style.opacity = '1';
          filterAnimationTimeout = null;
        }, 200);
      } else {
        const filterValue = item.getAttribute('data-full-value') || item.getAttribute('data-value');
        rebuildSwiper(targetTab, filterValue);
      }
    });
  });

  // Initialize
  document.querySelectorAll('.availability-calendar__tab-content-wrapper').forEach(wrapper => {
    const content = wrapper.querySelector('.availability-calendar__tab-content');
    if (content && content.classList.contains('is-active')) {
      wrapper.classList.add('is-active');
    }
  });
  
  // Load initial tab products
  loadTabProducts(currentActiveTab);
});

document.addEventListener('click', (e) => {
  if (!e.target) return;

  const card = e.target.closest('.product-card-wrapper--calendar');
  if (card) card.classList.toggle('is-open');
});